import { IconProps } from './Close';

const Icon = ({ size, backgroundColor, color }: IconProps) => {
  return (
    <svg
      id="User"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size || '18'}
      height={size || '18'}
      viewBox="0 0 48 48"
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="사각형_2061"
            data-name="사각형 2061"
            width={size || '18'}
            height={size || '18'}
            transform="translate(2644 12924)"
            fill={backgroundColor || '#fff'}
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g id="그룹_1814" data-name="그룹 1814" transform="translate(-2641 -12922)">
        <rect
          id="사각형_2060"
          data-name="사각형 2060"
          width="48"
          height="48"
          transform="translate(2641 12922)"
          fill="none"
        />
        <g
          id="마스크_그룹_166"
          data-name="마스크 그룹 166"
          transform="translate(-2 -1)"
          clipPath="url(#clip-path)"
        >
          <g id="Layer_2" data-name="Layer 2" transform="translate(2648.182 12924)">
            <g id="Layer_2-2" data-name="Layer 2">
              <path
                id="패스_857"
                data-name="패스 857"
                d="M36.591,44.864h0a1.045,1.045,0,0,1-1.045-1.045c-.491-9.346-7.778-16.727-16.727-16.727S2.593,34.5,2.091,43.818a1.045,1.045,0,0,1-1.045,1.045h0A1.045,1.045,0,0,1,0,43.818C.533,33.364,8.74,25,18.818,25s18.254,8.364,18.818,18.818A1.045,1.045,0,0,1,36.591,44.864Z"
                transform="translate(0 1.136)"
                fill={color || '#404040'}
              />
              <path
                id="패스_858"
                data-name="패스 858"
                d="M18.545,0A12.545,12.545,0,1,0,31.091,12.545,12.545,12.545,0,0,0,18.545,0Zm0,23A10.455,10.455,0,1,1,29,12.545,10.455,10.455,0,0,1,18.545,23Z"
                transform="translate(0.273)"
                fill={color || '#404040'}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Icon;
